import script from "./NeedHelpSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./NeedHelpSection.vue?vue&type=script&lang=ts&setup=true"

import "./NeedHelpSection.vue?vue&type=style&index=0&id=199c550a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-199c550a"]])

export default __exports__